import {Col, Row, Tooltip, Typography} from "antd";
import {InfoCircleFilled} from "@ant-design/icons";
import React from "react";

const Explainer = ({title, tooltip})=>{
  return (
      <Row wrap={false} align={'middle'}>
        <Col flex={'1'}>
          <Typography.Text strong>{title}</Typography.Text>
        </Col>
        <Col flex={'0 0 30px'}>
            <Tooltip title={tooltip} color={'#2db7f5'} style={{fontWeight: '300'}}>
                <InfoCircleFilled style={{fontSize: 20, color: '#1890ff'}}/>
            </Tooltip>
        </Col>
      </Row>
  )
}
export default Explainer;